import { gql } from "@apollo/client";

export const GET_COMPARE_FEATURES = gql`
  query getCompareFeatureData($contentTypeId: [String!]) {
    getCompareFeaturesData(
      filter: { content_type: { in: $contentTypeId }, status: { eq: true } }
      sort: { sort_order: ASC }
    ) {
      feature_id
      feature_name
      status
      content_type
      feature_description
      applicable_to
      feature_text_inclusion
      show_jurisdiction
      sort_order
      __typename
    }
  }
`;

export const GET_COMPARE_FEATURES_TYPE = gql`
  query getCompareFeatureContentType {
    getFeatureContentType(
      filter: { status: { eq: true } }
      sort: { sort_order: ASC }
    ) {
      content_type_id
      content_type
      status
      sort_order
      created_at
      updated_at
      __typename
    }
  }
`;
